'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _imageWithFallback = require('@liveauctioneers/caterwaul-components/lib/imageWithFallback');

var _imageWithFallback2 = _interopRequireDefault(_imageWithFallback);

var _reactFastCompare = require('react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _link = require('@liveauctioneers/caterwaul-components/lib/link');

var _link2 = _interopRequireDefault(_link);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LinkContainer = require('./LinkContainer.scss');

var _LinkContainer2 = _interopRequireDefault(_LinkContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columnKey = 0;

var LinkContainer = function (_Component) {
    (0, _inherits3.default)(LinkContainer, _Component);

    function LinkContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LinkContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LinkContainer.__proto__ || (0, _getPrototypeOf2.default)(LinkContainer)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = function (nextProps) {
            return !(0, _reactFastCompare2.default)(_this.props, nextProps);
        }, _this.mapLinks = function (link) {
            return (0, _jsx3.default)('li', {}, link.text, (0, _jsx3.default)(_link2.default, {
                onClick: _this.props.closeNav,
                route: true,
                to: link.route
            }, void 0, link.text));
        }, _this.mapColumn = function (columnObject) {
            // inline styling is a workaround for ie 10/11 and edge
            var ulStyle = {
                listStyle: 'none'
            };
            var title = columnObject.headerLink ? (0, _jsx3.default)(_link2.default, {
                className: _LinkContainer2.default['column-title'],
                route: true,
                to: columnObject.headerLink
            }, void 0, columnObject.headerText) : (0, _jsx3.default)('div', {
                className: _LinkContainer2.default['column-title']
            }, void 0, columnObject.headerText);
            return (0, _jsx3.default)('div', {}, columnObject.headerText, title, (0, _jsx3.default)('ul', {
                style: ulStyle
            }, void 0, columnObject.links.map(_this.mapLinks)));
        }, _this.mapLinkObjects = function (linkObject) {
            columnKey += 1;
            return (0, _jsx3.default)('div', {
                className: _LinkContainer2.default.column
            }, columnKey, (0, _jsx3.default)('div', {
                className: _LinkContainer2.default.wrapper
            }, void 0, linkObject.columnCategories.map(_this.mapColumn)));
        }, _this.generateColumns = function (linkObjects) {
            return (0, _jsx3.default)('div', {
                className: _LinkContainer2.default.container
            }, void 0, linkObjects.map(_this.mapLinkObjects));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(LinkContainer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                active = _props.active,
                linkArray = _props.linkArray,
                mobile = _props.mobile,
                picLinkL = _props.picLinkL,
                picLinkS = _props.picLinkS;

            var columns = this.generateColumns(linkArray);
            var isTablet = mobile === 'tablet';
            var pictureLink = isTablet ? picLinkS : picLinkL;

            return (0, _jsx3.default)('div', {
                className: _LinkContainer2.default.megaNav + ' ' + (active ? '' : 'hidden')
            }, void 0, (0, _jsx3.default)('div', {
                className: _LinkContainer2.default.seo
            }, void 0, columns, (picLinkL || picLinkS) && (0, _jsx3.default)(_imageWithFallback2.default, {
                src: pictureLink,
                className: _LinkContainer2.default.image
            })));
        }
    }]);
    return LinkContainer;
}(_react.Component);

exports.default = LinkContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Navigation/LinkContainer.js
// module id = 8s5y
// module chunks = 60